module.exports = __webpack_public_path__ + "static/media/einstein.68cca90b.jpg";